import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { checkInputErrorMaxLength, checkInputErrorRequired, useInput, useTextarea } from '@chilecompra/react-kit'
import { Input, Textarea, Typography } from '@chilecompra/react-kit/components'

import { useImperativeFormRef } from './QuoteStepOne.hooks'
import { Grid } from './QuoteStepOne.styles'

/**
 * The BasicInformation's component.
 */
const BasicInformation = props => {
  const { description, formRef, isDownToTiny, name } = props
  const {
    error: nameError,
    value: nameValue,
    onChange: handleNameChange
  } = useInput({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorMaxLength(200)],
    overwriteCallback: () => name
  })
  const {
    error: descriptionError,
    value: descriptionValue,
    onChange: handleDescriptionChange
  } = useTextarea({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorMaxLength(500)],
    overwriteCallback: () => description
  })
  const { authInfo } = useSelector(state => state.authorizationProvider)

  useImperativeFormRef(formRef, () => ({ descriptionError, descriptionValue, nameError, nameValue }), [
    descriptionError,
    descriptionValue,
    nameError,
    nameValue
  ])

  return (
    <Grid container margin="24px 0 24px">
      <Grid item direction="column" sm xs={12} padding="2px 32px 0 0">
        <Typography fontWeight="bold" variant="body2">
          Antecedentes básicos
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Ingresa información específica que ayude a los proveedores a cotizar en tu Compra Ágil.
        </Typography>
      </Grid>
      <Grid item sm={8} x={12}>
        <Grid container direction="column">
          <Grid item padding={isDownToTiny ? '16px 0 0' : '0'}>
            <Input
              disabled={authInfo.hasObserverRole}
              error={nameError}
              info="Este será el nombre que verán los proveedores al momento de cotizar."
              label="Nombre"
              maxCount={200}
              maxLength={200}
              value={nameValue}
              width="75%"
              onChange={handleNameChange}
            />
          </Grid>
          <Grid item>
            <Textarea
              disabled={authInfo.hasObserverRole}
              multiline
              error={descriptionError}
              info="Ingresa una descripción breve que explique tu Compra Ágil."
              label="Descripción"
              margin="8px 0 0 0"
              maxCount={500}
              maxLength={500}
              value={descriptionValue}
              width="75%"
              onChange={handleDescriptionChange}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

BasicInformation.defaultProps = {
  description: '',
  formRef: {
    current: {}
  },
  isDownToTiny: false,
  name: ''
}

BasicInformation.propTypes = {
  description: PropTypes.string,
  formRef: PropTypes.shape({
    current: PropTypes.shape(Object)
  }),
  isDownToTiny: PropTypes.bool,
  name: PropTypes.string
}

export default BasicInformation
